import React from 'react'
import classNames from 'classnames'

import ChirpSoapWidgetStyles from './ChirpSoapWidget.module.scss'

export interface ChirpSoapWidgetProps {
  actions?: React.ReactNode
  children: React.ReactNode
  classes?: {
    container?: string
    content?: string
    title?: string
  }
  id?: string
  title: string | React.ReactNode
}

const ChirpSoapWidget = ({
  classes: classesProp,
  actions,
  id,
  children,
  title,
}: ChirpSoapWidgetProps) => {
  const containerClassName = classNames(
    ChirpSoapWidgetStyles.container,
    classesProp?.container,
  )
  const titleClassName = classNames(
    ChirpSoapWidgetStyles.title,
    classesProp?.title,
  )
  const contentClassName = classNames(
    ChirpSoapWidgetStyles.content,
    classesProp?.content,
  )

  return (
    <div className={containerClassName} id={id}>
      <div className={titleClassName}>
        {React.isValidElement(title) ? (
          title
        ) : (
          <h2 className={ChirpSoapWidgetStyles.titleText}>{title}</h2>
        )}
        {actions && (
          <div className={ChirpSoapWidgetStyles.actions}>{actions}</div>
        )}
      </div>
      <div className={contentClassName}>{children}</div>
    </div>
  )
}

export default ChirpSoapWidget
